<script setup lang="ts">
import type { Product } from "@shopware-pwa/types";
import { Tint } from "~/components/clarity-ui/Tint";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import DiscountRateLabel from "~/templates/elements/DiscountRateLabel.vue";

export interface BulkProductPriceProps {
  product: Product;
  activeBulkChild: ProductBulkPrice;
}

const { isMobile } = useDevice();

defineProps<BulkProductPriceProps>();
</script>

<template>
  <div>
    <div class="flex items-center gap-3">
      <div v-if="activeBulkChild?.totalPrice" class="flex font-medium">
        <SharedPrice :value="activeBulkChild?.totalPrice" />&nbsp;<CommonLabel
          class="content-evenly text-sm"
          path="BWF/shop/checkout/plusTax"
        />
      </div>
      <div
        v-if="activeBulkChild?.totalPriceWithoutDiscount !== activeBulkChild?.totalPrice"
        class="relative flex items-center gap-x-4 pr-14 font-normal"
      >
        <Tint
          ><SharedPrice :value="activeBulkChild?.totalPriceWithoutDiscount" strikethrough
        /></Tint>
        <DiscountRateLabel
          v-if="!isMobile && activeBulkChild?.displayDiscountRate"
          class="absolute right-0"
          :discount-rate="activeBulkChild?.displayDiscountRate"
        />
      </div>
    </div>
    <Tint class="mt-1 text-sm" tag="p">
      <SharedPrice :value="activeBulkChild?.unitPrice" />&nbsp;<CommonLabel
        path="BWF/shop/shared/singleUnitPrice"
      />
    </Tint>
  </div>
</template>
